import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { Contact } from 'src/app/classes/models';
import { GridActionColumnActions } from 'src/app/interfaces/grid-action-column-actions';
import { GridActionColumnMap } from 'src/app/interfaces/grid-action-column-map';
import { AddEditContactModalComponent } from 'src/app/modals/add-edit-contact-modal/add-edit-contact-modal.component';
import { ContactService } from 'src/app/services/contact.service';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-site-contacts',
  templateUrl: './site-contacts.component.html',
  styleUrls: ['./site-contacts.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SiteContactsComponent {
  suppliedGridQueryData: { [key: string]: any } = {};
  ColumnIdToColumnActions: GridActionColumnMap = {
    ['$actionColumn']: ['edit', 'delete']
  };
  reloadGridData: boolean = false;
  sharedDataServiceSubscription!: Subscription;
  SiteId?: number;

  constructor(
    private SharedDataService: SharedDataService,
    private ModalService: NgbModal,
    private ToastService: ToastService,
    private ContactService: ContactService
  ) {
    this.sharedDataServiceSubscription =
      this.SharedDataService.listenForEvent<number>().subscribe({
        next: ({ eventName, data }) => {
          if (eventName === 'setSiteId' && typeof data === 'number') {
            this.SiteId = data;

            Object.assign(this.suppliedGridQueryData, { SiteId: this.SiteId });
          }
        }
      });

    this.SharedDataService.sendEvent('getSiteId');
  }

  onActionEvent({
    action,
    rowData
  }: {
    action: GridActionColumnActions;
    rowData: Contact;
  }) {
    if (!rowData || !rowData.id) {
      throw this.ToastService.addErrorToast(
        'Error',
        'No row data or id found.',
        { returnError: true }
      );
    }

    const { SiteId } = rowData;

    if (action === 'edit') {
      const modalRef = this.ModalService.open(AddEditContactModalComponent, {
        centered: true,
        size: 'lg'
      });
      modalRef.componentInstance.SiteId = this.SiteId;
      modalRef.componentInstance.isSiteContact = true;
      modalRef.componentInstance.useStreetAddress = true;
      modalRef.componentInstance.ContactId = rowData.id;
      modalRef.closed.subscribe({
        next: (result) => {
          if (result) {
            this.reloadGridData = true;
          }
        }
      });
    }

    if (action === 'delete') {
      if (!SiteId) {
        throw this.ToastService.addErrorToast(
          'Error',
          'Cannot delete contact. Missing Site ID.',
          { returnError: true }
        );
      }

      this.ContactService.deleteContact(rowData.id).subscribe({
        next: () => {
          this.ToastService.addSuccessToast(
            'Success',
            'Successfully deleted contact.'
          );
          this.reloadGridData = true;
        }
      });
    }
  }

  addContact() {
    const modalRef = this.ModalService.open(AddEditContactModalComponent, {
      centered: true,
      size: 'lg'
    });
    modalRef.componentInstance.SiteId = this.SiteId;
    modalRef.componentInstance.isSiteContact = true;
    modalRef.componentInstance.useStreetAddress = true;
    modalRef.closed.subscribe({
      next: (result) => {
        if (result) {
          this.reloadGridData = true;
        }
      }
    });
  }
}
